export default __webpack_public_path__ + "static/media/pexels-pixabay-45842.363e8bd9.jpg";